import React from 'react';
import PropTypes from 'prop-types';
import TopMenu from './TopMenu';
import Navigator from './navigation/Navigator';
import BottomView from './BottomView';
import ChannelGrid from './ChannelGrid';
import NoteGrid from './NoteGrid';

import ErrorStore from '../stores/ErrorStore';

export default class App extends React.Component {

	static contextTypes = {
		getStore: PropTypes.func.isRequired
	};

	constructor(props, context) {
		super(props, context);

		this.state = {
			error: context.getStore(ErrorStore).getError()
		}
	}

	componentDidMount() {
		this.context.getStore(ErrorStore).on("DISPLAY_ERROR", (err) => {
			this.setState({
				error: err
			})
		});
	}

	render() {

		var errorDisplay = "";

		if(this.state.error) {
			errorDisplay = this.state.error.message;
		}

		return (
			<div>
				{ errorDisplay ? <div className="error-display">{errorDisplay}</div> : ""}
				<TopMenu />
				<Navigator />
				<ChannelGrid />
				<NoteGrid />
				<BottomView />
			</div>
		);
	}
};
